<form class="form" [formGroup]="invoiceForm" (ngSubmit)="submit()">

  <label for="to" i18n>Queue:</label>
  <input id="to"
         type="email"
         autocorrect="off"
         autocapitalize="none"
         [value]="queue() || ''"
         (change)="queue.set($any($event.target).value)">

  <label for="qr" i18n>QR Code:</label>
  <div class="form-array">
    <input id="qr"
           type="text"
           [formControl]="url"
           (blur)="validate($any($event.target))">
    <app-qr-scanner (data)="$event && url.setValue($event)" />
  </div>

  <label for="title" i18n>Title:</label>
  <input id="title"
         type="text"
         [formControl]="title"
         (blur)="validate($any($event.target))">
  <span><!-- Title Errors --></span>
  <div>
    @if (titleRequired()) {
      <div class="error" i18n>
        Title must not be blank.
      </div>
    }
  </div>

  <span><!-- Message --></span>
  <div class="fill-editor">
    <app-editor #editor
                class="bubble"
                [control]="comment"
                [addButton]="true"
                i18n-addCommentTitle addCommentTitle="Add message"
                i18n-addCommentLabel addCommentLabel="+ Add message"
                (syncEditor)="syncEditor()"
                [tags]="invoiceFormValue()?.tags"
                (syncTags)="editorTags = $event"
                (uploadCompleted)="addCompletedUpload($event)" />
  </div>

  @for (e of serverError(); track e) {
    <span><!-- Unexpected Error --></span>
    <div class="error">{{ e }}</div>
  }

  <span><!-- Buttons --></span>
  <span class="buttons right floating">
      @if (submitting()) {
        <app-loading [inline]="true" />
      }
    <button type="submit" [disabled]="submitting() || submitted() && !invoiceFormValid()" i18n>Send</button>
  </span>
</form>
